import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

export function useClients(search: string) {
  return useQuery(allocationQueries.clients(search));
}
